import { getRCAData } from '@src/api/rca';
import { flattenData } from '@src/components/dimension-panel-hz/hooks/useFetchGroupBy';
import { get } from 'lodash';
import { useQuery } from 'react-query';

export const useRCA = (interval, metricFilter, filter) => {
  return useQuery(
    [interval, metricFilter, filter],
    async () => {
      if (!interval || metricFilter.length === 0) {
        return { metadataFilterData: {}, metricFilterData: {}, rcaData: [] };
      }
      const res = await getRCAData({ interval, metricFilter, filter }).then((response) => {
        const { metadataFilterData, metricFilterData, rcaData } = get(response, ['data'], {});
        return {
          metadataFilterData: flattenData(metadataFilterData, { metrics: [] }),
          metricFilterData: flattenData(metricFilterData, { metrics: [] }),
          rcaData,
        };
      });
      return res;
    },
    { retryOnMount: false, refetchOnWindowFocus: false },
  );
};
